import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {Helper} from "../../../../containers/AppPage/Reports/DepreciationSchedule/Helper";

function getColumns() {
    return [
        {
            key: 'name',
            dataKey: 'name',
            title: t`Name`,
            width: 0,
            flexGrow: 18,
            cellRenderer: Helper.renderName,
            required: true,
        },
        {
            key: 'code',
            dataKey: 'code',
            title: t`Code`,
            width: 0,
            flexGrow: 12,
            cellRenderer: Helper.renderCode,
        },
        {
            key: 'serial_number',
            dataKey: 'serial_number',
            title: t`Serial No.`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderText(rowData.serial_number, rowData),
        },
        {
            key: 'purchase_date',
            dataKey: 'purchase_date',
            title: t`Purchase Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderDate(rowData.purchase_date, rowData),
        },
        {
            key: 'depreciation_start_date',
            dataKey: 'depreciation_start_date',
            title: t`Dep Start Date`,
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderDate(rowData.depreciation_start_date, rowData),
        },
        {
            key: 'cost_price',
            dataKey: 'cost_price',
            title: t`Cost Price`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.cost_price,
                rowData.currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'cost_limit',
            dataKey: 'cost_limit',
            title: t`Cost Limit`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.cost_limit,
                rowData.currency_symbol,
                true,
            ),
        },
        {
            key: 'residual_value',
            dataKey: 'residual_value',
            title: t`Residual Value`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.residual_value,
                rowData.currency_symbol,
                true,
            ),
        },
        {
            key: 'depreciation_method',
            dataKey: 'depreciation_method',
            title: t`Dep Method`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderText(rowData.depreciation_method, rowData),
        },
        {
            key: 'depreciation_convention',
            dataKey: 'depreciation_convention',
            title: t`Dep Convention`,
            // align: 'left',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderText(rowData.depreciation_convention, rowData, false),
        },
        {
            key: 'depreciation_rate',
            dataKey: 'depreciation_rate',
            title: t`Dep Rate`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderText(rowData.depreciation_rate, rowData, false),
        },
        // {value: 'useful_life', label: t`Useful Life`},
        {
            key: 'opening_accumulated_depreciation',
            dataKey: 'opening_accumulated_depreciation',
            title: t`Opening Acc Dep`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.opening_accumulated_depreciation,
                rowData.currency_symbol,
            ),
        },
        {
            key: 'opening_value',
            dataKey: 'opening_value',
            title: t`Opening Value`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.opening_value,
                rowData.currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'purchase_value',
            dataKey: 'purchase_value',
            title: t`Purchase`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.purchase_value,
                rowData.currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'disposal_value',
            dataKey: 'disposal_value',
            title: t`Disposal`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.disposal_value,
                rowData.currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'depreciation_value',
            dataKey: 'depreciation_value',
            title: t`Depreciation`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.depreciation_value,
                rowData.currency_symbol,
            ),
            defaulto: true,
        },
        {
            key: 'closing_accumulated_depreciation',
            dataKey: 'closing_accumulated_depreciation',
            title: t`Closing Acc Dep`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.closing_accumulated_depreciation,
                rowData.currency_symbol,
            ),
        },
        {
            key: 'closing_value',
            dataKey: 'closing_value',
            title: t`Closing Value`,
            align: 'right',
            width: 0,
            flexGrow: 12,
            cellRenderer: ({rowData}) => Helper.renderAmount(
                rowData,
                rowData.closing_value,
                rowData.currency_symbol,
            ),
            required: true,
        },
    ];
}

export default {
    storageKey: StorageKey.report_depreciation,
    getReportLabel: () => t`Depreciation Schedule`,
    getColumns,
};
